import { useEffect, useState, useRef } from "react";
import { db } from "../../firebase";

export default function useCachedTreks(sort) {
  const [alltreks, setAllTreks] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [allMultiday, setAllMultiday] = useState([]);
  const hasFetchedRef = useRef(false); // ✅ Memory flag

  useEffect(() => {
    const fetchAllData = async () => {
      if (hasFetchedRef.current) return; // ✅ Prevent re-fetching on every mount
      hasFetchedRef.current = true;

      try {
        const localCache = JSON.parse(localStorage.getItem("cached-treks-data"));
        const now = new Date().getTime();

        // Check if cache exists & is recent (<30 min)
        if (localCache && now - localCache.timestamp < 30 * 60 * 1000) {
          setAllTreks(localCache.allTreks || []);
          setAllPackages(localCache.allPackages || []);
          setAllMultiday(localCache.allMultiday || []);
          return;
        }

        // 🔄 Fetch from Firestore if cache is old or not found
        const [trekSnap, winterAvailSnap, winterSnap, multiSnap] = await Promise.all([
          db.collection("All Trek").orderBy("price", sort).get(),
          db.collection("Trek Availability").doc("winterTrek").get(),
          db.collection("All Winter Trek").orderBy("price", sort).get(),
          db.collection("All MultiDay").orderBy("price", sort).get(),
        ]);

        const treks = trekSnap.docs.map(doc => doc.data().Details);
        const availability = winterAvailSnap.data();
        const winterTreks = availability?.availability === "show"
          ? winterSnap.docs.map(doc => doc.data().Details)
          : [];
        const multiTreks = multiSnap.docs.map(doc => doc.data().Details);

        // 🔥 Save to state
        setAllTreks(treks);
        setAllPackages(winterTreks);
        setAllMultiday(multiTreks);

        // 🗃️ Save to localStorage with timestamp
        localStorage.setItem("cached-treks-data", JSON.stringify({
          alltreks: treks,
          allPackages: winterTreks,
          allMultiday: multiTreks,
          timestamp: now,
        }));
      } catch (error) {
        console.error("Error fetching cached treks:", error);
      }
    };

    fetchAllData();
  }, [sort]);

  return {
    alltreks,
    setAllTreks,
    allPackages,
    setAllPackages,
    allMultiday,
    setAllMultiday
  };
}
